document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.hero-carousel').forEach(function (carousel) {
    var slides = carousel.querySelectorAll('.hero-carousel__slide');
    var dots = carousel.querySelectorAll('.hero-carousel__dot');
    var prevBtn = carousel.querySelector('.hero-carousel__arrow--prev');
    var nextBtn = carousel.querySelector('.hero-carousel__arrow--next');
    if (slides.length <= 1) return;

    var current = 0;
    var autoplay = carousel.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(carousel.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (dots[current]) {
        dots[current].classList.remove('is-active');
        dots[current].setAttribute('aria-selected', 'false');
      }
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) {
        dots[current].classList.add('is-active');
        dots[current].setAttribute('aria-selected', 'true');
      }
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    if (nextBtn) nextBtn.addEventListener('click', function () { next(); restart(); });
    if (prevBtn) prevBtn.addEventListener('click', function () { prev(); restart(); });
    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); restart(); });
    });

    function start() {
      if (!autoplay || reduceMotion) return;
      timer = setInterval(next, speed);
    }
    function stop() {
      if (timer) clearInterval(timer);
    }
    function restart() { stop(); start(); }

    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('mouseleave', start);

    start();
  });
});
